<template>
    <div id="tansfer">
        <a-modal title="Transfer" :visible="visible" width="85%" @cancel="transferCancel" :maskClosable=false :footer="null">
            <a-form :form="form">
                <!-- warehouse -->
                <a-form-item :label="$t('userlang.Warehouse')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select show-search optionFilterProp="label" size="small" :disabled="true"
                        :placeholder="$t('publicLang.PleaseSelect')" v-decorator="[
                                'warehouseCode',
                                {
                                  initialValue: warehouseCode,
                                  rules: [{
                                    required: true,
                                    message: $t('publicLang.Required')
                                  }]
                                }
                              ]">
                        <a-select-option :label="item.whsName" :value="item.whsCode" :key="item.whsCode"
                            v-for="item in wareHouseSelect">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-form-item>

                <!-- reasonCode -->
                <a-form-item label="Reason" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select allowClear show-search optionFilterProp="label" size="small"
                        :placeholder="$t('publicLang.PleaseSelect')" @change="stepChange" v-decorator="[
                                'reasonCode',
                                {
                                  initialValue: reasonCode,
                                  rules: [{
                                    required: this.reasonMandatory,
                                    message: $t('publicLang.Required')
                                  }]
                                }
                              ]">
                        <a-select-option v-for="item in transferReasonSelectData" :label="item.codeDesc"
                            :value="item.code" :key="item.code">{{item.codeDesc}}</a-select-option>
                    </a-select>
                </a-form-item>

                <!-- reasonCode2 -->
                <a-form-item label="Reason2" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select allowClear show-search optionFilterProp="label" size="small"
                        :placeholder="$t('publicLang.PleaseSelect')" @change="stepChange" v-decorator="[
                                'reasonCode2',
                                {
                                  initialValue: reasonCode2,
                                  rules: [{
                                    required: this.reason2Mandatory,
                                    message: $t('publicLang.Required')
                                  }]
                                }
                              ]">
                        <a-select-option v-for="item in transferReason2SelectData" :label="item.codeDesc"
                            :value="item.code" :key="item.code">{{item.codeDesc}}</a-select-option>
                    </a-select>
                </a-form-item>


                <!-- Remarks -->
                <a-form-item :label="$t('pubGicSet.Remarks')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-textarea :placeholder="$t('publicLang.PleaseEnter')" :rows="3" size="small"
                        v-model="remarksVal" />
                </a-form-item>

            </a-form>

            <a-col style="float:right;">
                <a-button class="mg5" size="small" type="primary" @click="transFerSave" style="margin-right: 8px"
                          v-if="headerStatus != '00' ? false : true">
                    {{ $t('publicLang.Save') }}</a-button>
                <a-button class="mg5" size="small" type="primary" @click="addTransfer"
                          v-if="headerStatus != '00' ? false : true">{{ $t('pubGicSet.Search') }}</a-button>
            </a-col>

            <a-divider style="margin: 10px 0px" />

            <a-row style="margin-bottom: 10px;">
                <a-col style="float:left;">
                    <!-- CLOSE  -->
                    <a-button size="small" @click="transferCancel">{{ $t('publicLang.Close') }}</a-button>

                    <!-- save inv transfer Detail  -->
                    <a-button class="mg5" size="small" type="primary" @click="saveInvTransderDetails"
                             v-if="headerStatus != '00' ? false : true"
                              :disabled="this.transaTableData.length > 0 ? this.isShowUpdateTransferDetailBTN : true">{{ $t('publicLang.Save') }}</a-button>

                    <!-- cancel -->
                    <a-popconfirm :title="$t('publicLang.Arecancel')" @confirm="cancelTransfer"
                                  :okText="$t('publicLang.Yes')" :cancelText="$t('publicLang.No')">
                        <a-button class="mg5" size="small" type="primary" v-if="headerStatus != '00' ? false : true">
                            {{ $t('publicLang.Cancel') }}</a-button>
                    </a-popconfirm>


                    <!-- confirm  -->
                    <a-popconfirm :title="$t('publicLang.Areconfirm')" @confirm="confirmTransfer"
                                  :okText="$t('publicLang.Yes')" :cancelText="$t('publicLang.No')">
                        <a-button class="mg5" size="small" type="primary"
                                  :style="transaTableData.size > 0 ? '':'margin-left: 5px;'"
                                  v-if="headerStatus != '00' ? false : true"
                                  :disabled="this.transaTableData.length > 0 ? false : true">{{ $t('publicLang.Confirm') }}
                        </a-button>
                    </a-popconfirm>

                    <!--添加库位输入框,如果有值则代替下方列表To Location的值 Liyy 2023-3-30-->
                    <b style="margin-left: 5px;">{{$t('pubGicSet.Location')}}:</b>
                    <a-auto-complete style="width: 200px;border: 0px solid;" @search="handleSearch" :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="topLocation">
                        <template slot="dataSource">
                            <a-select-option v-for="item in completeData" :key="item.locationCode"  :value="item.locationCode">{{item.locationName}}</a-select-option>
                        </template>
                    </a-auto-complete>
                </a-col>

            </a-row>

            <vxe-table 
            
            
                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                     
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        align="center"
                        :data.sync="transaTableData"
                        class="mytable-style "
                        max-height="350"
                        ref="refTransferDetailTab"
                        size="mini"
                    >

                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column field="fromLocation" :title="$t('pubGicSet.Location')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"> </vxe-table-column>
                <vxe-table-column field="fromSku" :title="$t('pubGicSet.FromSku')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="logicWhs" :title="$t('pubGicSet.LogicalWH')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="avBaseQty" :title="$t('pubGicSet.FromQty')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>


                <vxe-table-column field="toSku" :title="$t('pubGicSet.ToSku')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-input v-model="row.toSku" :placeholder="$t('publicLang.PleaseEnter')" size="small"
                            style="width: 100%;"  @change="handleChange" />
                    </template>
                </vxe-table-column>


                <vxe-table-column field="transferQty" :title="$t('pubGicSet.ToQty')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-input-number v-model="row.transferQty" :placeholder="$t('publicLang.PleaseEnter')"
                            size="small" style="width: 100%;"  @change="handleChange" />
                    </template>
                </vxe-table-column>

                <vxe-table-column field="toLocation" :title="$t('pubGicSet.ToLocation')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-auto-complete style="width: 100%" @search="searchMovehandleSearch"
                            :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="row.toLocation" @change="handleChange"
                            class="adjmvtrIpt">
                            <template slot="dataSource">
                                <a-select-option v-for="item in TransferCompleteData" :key="item.locationCode"
                                    :value="item.locationCode">{{item.locationName}}</a-select-option>
                            </template>
                        </a-auto-complete>
                    </template>
                </vxe-table-column>

                <vxe-table-column :title="$t('generic.operate')" width="150" show-header-overflow="ellipsis"
                    show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <img style="margin-left: 4px" @click="deleteRows(row)" class="sbxs"
                            src="../../../assets/img/ss-delete.png" width="22" height="22"
                            v-if="row.status != '00' ? false : true">
                        <a-button style="margin-left: 4px;" size="small" type="primary" shape="circle" icon="search"
                            @click="transferView(row)"></a-button>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-modal>
        <transfer-search ref="transferAdvan" :searTableUid="transSearTableUid" :adjustParHeaderId="transHeaderUid"
            :waseCode="transWarehouse" v-on:getAdjustData="getAdjustData" :ajtype="adjust"></transfer-search>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import adjustAdvan from './adjustAdvanSearch/adjustAdvanSearch.vue'
    import transferSearch from './adjustAdvanSearch/transferSearch.vue'
    export default {
        components: {
            transferSearch
        },
        data() {
            return {
                TransferCompleteData: [],
                remarksVal: '',
                visible: false,
                //                表单
                form: this.$form.createForm(this),
                wareHouseSelect: [],
                transferlogicSelectData: [],
                //                表格
                transaTableData: [],
                transHeaderUid: '',
                transSearTableUid: '',
                transWarehouse: '',
                adjust: 'transferDetail',
                wareHourseDis: false,
                logicTransVal: '',
                isTransfercCancel: true,
                isTransSave: true,
                transitDis: true,
                isInTransitMark: true,
                tranIfcancel: true,
                tranIfSearch: true,
                isTransit: false,
                editTransferData: {},
                transferReasonSelectData: [],
                transferReason2SelectData: [],
                reasonCode: "",
                reasonCode2: "",
                headerStatus: "",
                warehouseCode: "",
                reasonMandatory: false,
                reason2Mandatory: false,
                topLocation: "",
                completeData: [],
                isShowUpdateTransferDetailBTN: true
            }
        },
        methods: {

          handleChange(){
                 let records = this.$refs.refTransferDetailTab.getRecordset();
                 console.info(records)
                 let updateRecords = records.updateRecords
                 if(updateRecords != null && updateRecords.length > 0){
                    this.isShowUpdateTransferDetailBTN = false
                 }else{
                    this.isShowUpdateTransferDetailBTN = true
                 }
            },

        checkData(array,isIgnoreTopToLocation){
            
            if(array != null && array.length > 0){
                let errorMsg = '';
                let toSkuEmpty = '';
                let toLocationEmpty = '';
                let notEnoughInventory = '';

                for(let i in array){
                     let row = array[i];
                     let sku  = row.fromSku;
                     let  fromLocation = row.fromLocation;
                     let toSku = row.toSku;

                     let msg = "SKU#"+sku+" "+fromLocation


                    let topLocationIsNull = (this.topLocation == null || this.topLocation == '') ;

                    if(isIgnoreTopToLocation){
                        topLocationIsNull = true;
                    }

                     if ( topLocationIsNull  && (row.toLocation == null || row.toLocation == '')) {
                            if(toLocationEmpty.indexOf(msg) > -1){
                              continue;
                             } 
                             if(toLocationEmpty.length > 0){
                                 toLocationEmpty += ','
                             }
                             toLocationEmpty += msg
                     }
                     



                     if (toSku == null || toSku == '' ||  toSku =='null') {
                         console.info('999')
                        if(toSkuEmpty.indexOf(msg) > -1){
                            continue;
                        } 
                        if(toSkuEmpty.length > 0){
                            toSkuEmpty += ','
                        }
                        toSkuEmpty += msg
                     }
                     

                     if(parseInt(row.transferQty) > row.avBaseQty ){
                       

                         if(notEnoughInventory.indexOf(msg) > -1){
                            continue;
                        } 

                        if(notEnoughInventory.length > 0){
                            notEnoughInventory += ','
                        }
                        notEnoughInventory += msg
                     }
                }     
               
               
               if(toSkuEmpty.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += toSkuEmpty+" "+this.$t("pubGicSet.ToSkuCannotBeEmpty");
                } 
                
                if(toLocationEmpty.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += toLocationEmpty+" "+this.$t("pubGicSet.ToLocationCannotBeEmpty");
                } 
                   
                if(notEnoughInventory.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += notEnoughInventory +" "+this.$t("pubGicSet.NotEnoughInventoryToMove");
                 } 
                
                if(errorMsg.length > 0){
                       throw new Error(errorMsg);
                }    
            }
        },





            saveInvTransderDetails() {

                let records = this.$refs.refTransferDetailTab.getRecordset();
                let updateRecords = records.updateRecords
                if(updateRecords == null || updateRecords.length == 0){
                   this.$customMessage.error(this.$t("pubGicSet.DataNotChange"));
                   return;
                }

                 try{
                     this.checkData(updateRecords,true);  
                 } catch (error){
                    this.$customMessage.error(error.message);
                    return;
                 }
    
                   ajax.post(api.UPDATTEINVTRANSFERDETAIL, updateRecords).then(res => {
                       if (res.code == 200) {
                           this.form.resetFields(); 
                           this.show2(this.transHeaderUid,false,false)
                           this.$message.success(res.msg);
                       } else {
                           this.$customMessage.warning(res.msg);
                       }
                   })

            },


            searchMovehandleSearch(val) {
                if (val == ''  ||  val.length < 4) {
                    return
                }
                let params = {
                    whsCode: this.warehouseCode,
                    keyword: val,
                }
                ajax.post(api.INVENTORYLOCATION, params).then(res => {
                    this.TransferCompleteData = res.data
                })
            },
            stepChange(val) {
                if (val == 'Translit') {
                    this.transitDis = false
                    this.isTransit = true
                } else {
                    this.isTransit = false
                }
            },
            wareHouseTransChange(val) {
                this.warehouseCode = val
            },
            logicTransChange(val) {
                this.logicTransVal = val
            },

            show2(uid,showEditUdf,init) {
                if(init){ this.init(); }
                ajax.get(api.INVENTORYINVTRANSFERINFO, {
                    uid: uid
                }).then(res => {
                    if (res.code == 200) {
                        this.headerStatus = res.data.status
                        this.transaTableData = res.data.invTransferDetailDto2s
                        this.transHeaderUid = res.data.uid
                        this.remarksVal = res.data.remarks
                        this.transSearTableUid = res.data.gmcUid
                        this.reasonCode = res.data.reasonCode
                        this.reasonCode2 = res.data.reasonCode2
                        this.visible = true;
                        this.isShowUpdateTransferDetailBTN= true;
                        
                      if(showEditUdf){
                          this.$refs.transferAdvan.show('showEditUdf',[],"")
                       }


                            // let locationCodes = '';
                            //  for(let i in  this.transaTableData){
                            //     let locationCode =  this.transaTableData[i].toLocation
                            //     if(locationCode != null && locationCode != ''){
                            //            if(locationCodes.length > 0){
                            //                 locationCodes = locationCodes +','+locationCode
                            //            }else{
                            //                 locationCodes =  locationCode
                            //            }
                            //     }
                            // }
                            // this.searchMovehandleSearch(locationCodes)


                    } else {
                        this.$customMessage.error(res.msg);
                    }
                })
                
            },





/**
 * Enquiry(Location) 页面操作生成 transfer
 */

            show(params) {
                if (params != null) {
                    ajax.post(api.EDITINVRNTORYINVSAVE, params).then(res => { 
                        if (res.code == 501) {
                            this.visible = false
                            this.$customMessage.error(res.msg);
                            return
                        } else if (res.code == 200) { 
                            this.transHeaderUid = res.data.uid;
                           this.show2(this.transHeaderUid,true,true)                       
                        }
                    })
                } else {
                    this.init();
                    this.visible = true
                }
            },


            transferCancel() {
                this.visible = false
                this.isTransSave = true
                this.form.resetFields();
                this.editTransferData = {}
                this.wareHourseDis = false
                this.isTransfercCancel = true
                this.tranIfcancel = true
                this.tranIfSearch = true
                this.transHeaderUid = ''
                this.remarksVal = ''
                this.transaTableData = []
                this.topLocation=""
            },
            init() {
                this.headerStatus = ''
                this.transHeaderUid = ''
                this.reasonCode = ''
                this.reasonCode2 = ''
                this.remarksVal = ''
                this.warehouseCode = ''
              
                this.transaTableData = []
                this.form.resetFields();

                ajax.get(api.USERDROPDOWNWHS).then(res => {
                    if (res.code == 200) {
                        this.wareHouseSelect = res.data.warehouseList
                        this.warehouseCode = res.data.warehouseCode
                    }
                })
                ajax.get(api.TRANSFERREASONSELECT).then(res => {
                    this.transferReasonSelectData = res.data.reasons
                    this.transferReason2SelectData = res.data.reasons2
                    this.reasonMandatory = res.data.reasonMandatory
                    this.reason2Mandatory = res.data.reason2Mandatory
                })
            },
            transFerSave() {
                this.form.validateFields((err, val) => {
                    if (!err) {
                        let params = {
                            logic: this.logicTransVal,
                            remarks: this.remarksVal,
                            whsCode: this.warehouseCode,
                            transferType: val.transferType,
                            reasonCode: val.reasonCode,
                            reasonCode2: val.reasonCode2,
                            uid: this.transHeaderUid,
                            updateInvDetailVos: []
                        }
                        ajax.post(api.INVTRANSFERHEADER, params).then(res => {

                            if (res.code == 200) {
                                this.transHeaderUid = res.data.headerUid
                                this.transSearTableUid = res.data.gmcUid
                                this.headerStatus = res.data.status
                                this.$message.success(res.msg);
                            } else {
                                this.$customMessage.error(res.msg)
                            }
                        })

                    }
                })
            },
            addTransfer() {
                this.$refs.transferAdvan.show()
            },
            getAdjustData(val) {
                this.transaTableData = val
                this.isShowUpdateTransferDetailBTN= true;
            },
            cancelTransfer() {
                ajax.post(api.INVTRANSFERHEADERCANCEL, {
                    uid: this.transHeaderUid
                }).then(res => {
                    if (res.code == 200) {
                        this.headerStatus = '90'
                          for(let i in this.transaTableData){
                            this.transaTableData[i].status = '90'
                        }
                        this.$message.success(res.msg);
                    } else {
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            transferView(row) {
                let params = {
                    batchNo: row.batchNo,
                    headerUid: this.transHeaderUid,
                    detailUid: row.uid,
                    keyValueKit: []
                }
                ajax.post(api.INVENTORYINVTRANSFERUDF, params).then(res => {
                    let  arr = res.data.dataMap
                    this.$refs.transferAdvan.show('showEditUdf',arr,row.uid,row.status)
                    // this.$refs.transferAdvan.show('showEditUdf', [], res.data.batchNo)
                })
                //   this.$refs.transferAdvan.show('showEditUdf',null,res.data.batchNo)

            },
            deleteRows(row) {
              
                //    let data = this.transaTableData;
                //    let index = -1;
                //    for(let i  in data){
                //        if(row.uid == data[i].uid) {
                //             index = i ;
                //             break;
                //        }
                //    }

                ajax.post(api.DELINVTRANSFERDETAIL, {
                    uid: row.uid,
                    headerUid: this.transHeaderUid,
                    batchNo: row.batchNo
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                          this.$refs.refTransferDetailTab.remove(row)
                        //   if(index >= 0){
                        //     this.transaTableData.splice(index,1);
                        //   }
                    } else {
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            confirmTransfer() {
                 this.form.validateFields((err, val) => {
                    if (!err) {    
                         if(!(this.isShowUpdateTransferDetailBTN)){
                               this.$customMessage.error(this.$t("pubGicSet.DataModifyNotSave"));
                               return;
                          }

                         try{
                              this.checkData(this.transaTableData,false);  
                          } catch (error){
                             this.$customMessage.error(error.message);
                             return;
                          }

                         let params = {
                             remarks: this.remarksVal,
                             whsCode: this.warehouseCode,
                             uid: this.transHeaderUid,
                             topLocation: this.topLocation,
                             reasonCode: val.reasonCode,
                             reasonCode2: val.reasonCode2,
                         }
                         ajax.post(api.TRANSFERHEADERCONFIRM, params).then(res => {
                             if (res.code == 200) {
                                 this.headerStatus = '10'
                                 // for(let i in this.transaTableData){
                                 //     this.transaTableData[i].status = '10'
                                 // }
                                  this.show2(this.transHeaderUid,false,false)
                                 this.$message.success(res.msg);
                                 this.topLocation = ""
                             } else {
                                 this.$customMessage.error(res.msg);
                             }
                         })
                    }
                })
            },
            handleSearch(value) {
                if (value == '' || value.length < 4) {
                    return
                }
                ajax.post(api.INVENTORYLOCATION, { keyword: value}).then(res => {
                    this.completeData = res.data
                })
            },
        }
    }
</script>
<style lang="less">
    #tansfer {
        .tableSpanClass {
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            display: block;
        }
    }
</style>